import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const GuestGuard = ({ children }) => {
  const { token } = useAuth();

  if (token) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default GuestGuard;
